"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createDefaultContainsActiveRouteChecker = void 0;

var _createDefaultActiveRouteChecker = require("./createDefaultActiveRouteChecker");

var createDefaultContainsActiveRouteChecker = function createDefaultContainsActiveRouteChecker(currentPath) {
  return function (route) {
    return Boolean(route.routes && Array.isArray(route.routes) && route.routes.find((0, _createDefaultActiveRouteChecker.createDefaultActiveRouteChecker)(currentPath)));
  };
};

exports.createDefaultContainsActiveRouteChecker = createDefaultContainsActiveRouteChecker;
var _default = createDefaultContainsActiveRouteChecker;
exports.default = _default;